<div class="filters-row">
  <app-users-filter [selectedTypeIds]="selectedTypeIds" [storageKey]="'us_users_filter_selectedUserIds'" (filterChange)="onUsersFilterChange($event)"></app-users-filter>
  <div class="filter-actions">
    <button mat-button class="filter-btn" (click)="scrollToToday()">Current date</button>
    <button mat-button class="filter-btn icon-btn" [class.active]="isSplitMode" (click)="toggleSplitMode()"><mat-icon>content_cut</mat-icon></button>
    <button mat-button class="filter-btn icon-btn" (click)="changeDayWidth(-20)"><i class="pi pi-minus"></i></button>
    <button mat-button class="filter-btn icon-btn" (click)="changeDayWidth(20)"><i class="pi pi-plus"></i></button>
  </div>
  <div class="delete-drop-area"
       #deleteDropArea
       [class.drag-over]="isOverDeleteArea"
       [class.drag]="isDraggingEvent"
       (mouseenter)="onDeleteAreaEnter()"
       (mouseleave)="onDeleteAreaLeave()"
       (mouseup)="onDeleteAreaDrop($event)">
    <mat-icon>delete</mat-icon>
    <span>Drop to delete</span>
  </div>
</div>

<div class="user-schedule-container" #scheduleContent>
  <div class="schedule-table">

    <!-- Header -->
    <div class="header-row">
      <div class="user-column-header sticky-col">Installers</div>
      <div class="timeline-header" [style.width.px]="days.length * dayWidth">
        <div class="day-cell" *ngFor="let day of days; let i = index; trackBy: trackByDayIndex"
             [style.width.px]="dayWidth"
             [class.today]="isToday(day)"
             [class.friday-border]="isFriday(day)"
             [class.weekend]="isWeekend(day)"
             [class.drag-highlight]="highlightedDayIndex === i">
          <div class="day-name">{{ day | date: 'EEE' }}</div>
          <div class="day-number">{{ day | date: 'MMM d' }}</div>
        </div>
      </div>
    </div>

    <!-- Users -->
    <div class="body-row" *ngFor="let user of users; let i = index; trackBy: trackByUserId"
         [style.height.px]="userRowHeights.get(user.id)"
         [class.drag-highlight]="highlightedUserId === user.id"
         [class.user-drop-target]="dropTargetUserIndex === i && isDraggingUser">
      <div class="user-cell-wrapper sticky-col">
        <div class="user-cell">
          <div class="user-drag-handle"
               (mousedown)="onUserDragStart(user, i, $event)"
               (touchstart)="onUserTouchStart(user, i, $event)"
               [class.dragging]="isDraggingUser && draggedUserIndex === i"
               [class.tablet]="isTablet">
            <mat-icon>drag_indicator</mat-icon>
          </div>
          <div class="avatar-block">
            <div class="word-avatar" [style.background-color]="'#' + user.bgColor">
              <div class="short-name">
                {{user.shortCode}}
              </div>
            </div>
          </div>
          <div class="user-name">
            {{ user.name }}
          </div>
        </div>
      </div>
      <div class="events-timeline"
           [style.width.px]="days.length * dayWidth"
           [ngStyle]="getGridStyle()">
        <div class="event-item"
             *ngFor="let item of userActivities.get(user.id); trackBy: trackByActivityId"
             [attr.data-activity-id]="item.activity.id"
             [style.left.px]="getEventPosition(item.activity).left"
             [style.width.px]="getEventPosition(item.activity).width"
             [style.top.px]="item.rowIndex * rowHeight + 8"
             [ngStyle]="getEventBackgroundStyle(item.activity)"
             [class.overlap-indication]="item.overlaps"
             [class.ready]="item.activity.ready"
             [class.split-mode-selected]="isEventInSplitMode(item.activity)"
             [class.split-mode-active]="isSplitMode && canSplitActivity(item.activity)"
             [class.cursor-col-resize]="isSplitMode && hoveredSplitGuideIndex >= 0"
             (mousedown)="!isSplitMode && onEventMouseDown(item.activity, $event)"
             (touchstart)="!isSplitMode && onEventTouchStart(item.activity, $event)"
             (click)="isSplitMode ? onEventClickSplitMode(item.activity, $event) : onEventClick(item.activity, $event)"
             (mousemove)="isSplitMode && onSplitEventMouseMove(item.activity, $event)"
             (mouseenter)="showHint(item.activity, $event)"
             (mouseleave)="isSplitMode ? onSplitEventMouseLeave() : hideHint()">
          <span class="event-title">{{ item.activity.project.name }}</span>
          <span class="event-type">{{ item.activity.type.shortCode }}</span>
          <div *ngIf="hasMultipleUsers(item.activity)" class="chain-icon" (click)="onChainIconClick(item.activity, $event)">
            <mat-icon>people</mat-icon>
          </div>
          <div class="add-icon" (click)="onAddActivityClick(item.activity, $event)"
               [class.tablet]="isTablet">
            <mat-icon>add</mat-icon>
          </div>
          <div *ngIf="isSplitMode && canSplitActivity(item.activity)" class="split-guides">
            <div *ngFor="let guide of getSplitGuides(item.activity)"
                 class="split-guide-line"
                 [style.left.px]="guide.position"
                 [class.active]="guide.dayIndex === hoveredSplitGuideIndex">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Unassigned -->
    <div class="body-row unassigned-row" [style.height.px]="unassignedRowHeight" *ngIf="showUnassigned"
         [class.drag-highlight]="highlightedUnassigned">
      <div class="user-cell-wrapper unassigned-row sticky-col">
        <div class="user-cell left-pad">
          Unassigned
        </div>
      </div>
      <div class="events-timeline"
           [style.width.px]="days.length * dayWidth"
           [ngStyle]="getGridStyle()">
        <div class="event-item"
             *ngFor="let item of unassignedActivities; trackBy: trackByActivityId"
             [attr.data-activity-id]="item.activity.id"
             [style.left.px]="getEventPosition(item.activity).left"
             [style.width.px]="getEventPosition(item.activity).width"
             [style.top.px]="item.rowIndex * rowHeight + 8"
             [ngStyle]="getEventBackgroundStyle(item.activity)"
             [class.overlap-indication]="item.overlaps"
             [class.ready]="item.activity.ready"
             [class.split-mode-selected]="isEventInSplitMode(item.activity)"
             (mousedown)="!isSplitMode && onEventMouseDown(item.activity, $event)"
             (click)="isSplitMode ? onEventClickSplitMode(item.activity, $event) : onEventClick(item.activity, $event)"
             (mousemove)="isSplitMode && onSplitEventMouseMove(item.activity, $event)"
             (mouseenter)="showHint(item.activity, $event)"
             (mouseleave)="isSplitMode ? onSplitEventMouseLeave() : hideHint()">
          <span class="event-title">{{ item.activity.project.name }}</span>
          <span class="event-type">{{ item.activity.type.shortCode }}</span>
          <div *ngIf="hasMultipleUsers(item.activity)" class="chain-icon" (click)="onChainIconClick(item.activity, $event)">
            <mat-icon>link</mat-icon>
          </div>
          <div *ngIf="isSplitMode && canSplitActivity(item.activity)" class="split-guides">
            <div *ngFor="let guide of getSplitGuides(item.activity)"
                 class="split-guide-line"
                 [style.left.px]="guide.position"
                 [class.active]="guide.dayIndex === hoveredSplitGuideIndex">
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<p-overlayPanel #eventHintOP styleClass="overlay-panel event-panel">
  <ng-container *ngIf="activityInHint">
    <app-event-tip [activityInHint]="activityInHint"></app-event-tip>
  </ng-container>
</p-overlayPanel>

<p-confirmDialog appendTo="body" icon="pi pi-exclamation-triangle" styleClass="schedule-panel">
</p-confirmDialog>

